import React from "react";
import { useTranslation } from "react-i18next";
import { VelavuRole } from "velavu-js-api";
import IconInfo from "../../dynamicicons/icon-info";
import HoverTooltip from "../../elements/hover-tooltip";
import { mapUserRole } from "../../helper/language-helper";
import whitelabel from "../../whitelabel";
import * as styles from "./settings-roles-tooltip.module.scss";

const roles = [
	{
		role: VelavuRole.Viewer,
		descriptionKey: "settings.roles_tooltip.viewer",
	},
	{
		role: VelavuRole.Operator,
		descriptionKey: "settings.roles_tooltip.operator",
	},
	{
		role: VelavuRole.SiteManager,
		descriptionKey: "settings.roles_tooltip.site_manager",
	},
	{
		role: VelavuRole.Admin,
		descriptionKey: "settings.roles_tooltip.admin",
	},
] as const;

export default function SettingsRolesTooltip() {
	const { t } = useTranslation();

	return (
		<HoverTooltip
			fixed
			className={styles.tooltip}
			tooltip={
				<div className={styles.roleTable}>
					{roles.map(({ role, descriptionKey }) => (
						<div className={styles.roleRow} key={role}>
							<span className={styles.roleName}>
								{mapUserRole(role, t)}
							</span>
							<span className={styles.roleDescription}>
								{t(descriptionKey)}
							</span>
						</div>
					))}
				</div>
			}
		>
			<span
				className={styles.wrapper}
				aria-label={t("settings.roles_tooltip.label")}
				role="img"
			>
				<IconInfo size={16} color="currentColor" />
			</span>
		</HoverTooltip>
	);
}
